import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import {cryptoJs} from '@deanwu/vue-component-library'
import dictList from './dict.js'

const dictData = {};
for (let key in dictList) {
	dictData[`${key}Data`] = stateSerialize(dictList[key]);
}
function stateSerialize(data) {
	let json = {};
	data.forEach(item => {
		if (typeof item.value == 'object') {
			item.value.forEach(i => {
				json[i] = item;
			});
		} else {
			json[item.value] = item;
		}
	});
	
	return json;
}

Vue.use(Vuex);

let app = new Vue();
const Store = new Vuex.Store({
	state: {
		...dictList,
		dictData: {
			...dictData
		},
		asyncDictList: {},
		asyncDictData: {},
		session: '',
		saasInfo: {},
		userInfo: {},
		authList: [],  // 权限
		navList: [],  // 导航菜单
		publicConfig: {}
	},

	mutations: {
		updateAsyncDict(state, data) {
			Vue.set(state.asyncDictList, data.dict, data.data);
			Vue.set(state.asyncDictData, `${data.dict}Data`, stateSerialize(data.data));
		},
		
		setSystemConfig(state, data) {
			state.publicConfig = data;
		},
		
		setSession(state, data) {
			state.session = data;
		},
		
		// 设置企业信息
		setSaasInfo(state, data) {
			state.saasInfo = data;
		},
		
		// 设置用户信息
		setUserInfo(state, data) {
			delete data.session;
			state.userInfo = data;
		},
		
		// 设置权限列表
		setAuth(state, data) {
			state.authList = data;
		},
		
		// 设置导航菜单
		setNav(state, data) {
			data.unshift({
				id: 1,
				menu_name: '工作台',
				menu_unique_key: 'home',
				first_menu_id: 2
			});
			data.forEach(menu => {
				while (menu.child_menu_list && menu.child_menu_list.find(item => item.child_menu_list && item.child_menu_list.length)) {
					let index = menu.child_menu_list.findIndex(item => item.child_menu_list && item.child_menu_list.length);
					let target = menu.child_menu_list.find(item => item.child_menu_list && item.child_menu_list.length);
					target.child_menu_list.forEach(item => item.is_child = true);
					menu.child_menu_list.splice.apply(menu.child_menu_list, [index + 1, 0].concat(target.child_menu_list));
					target.is_parent = true;
					target.child_menu_list = null;
				}
			});
			state.navList = data;
		}
	},

	actions: {
		updateLoginInfo(store) {
			app.request({
				url: '/sys_user/get_login_info',
				success: data => {
					store.dispatch('setLoginInfo', data);
				}
			})
		},
		
		updateSystemConfig(store) {
			app.request({
				url: '/sys/config',
				success: data => {
					store.commit('setSystemConfig', data);
				}
			})
		},

		setLoginInfo(store, data) {
			store.commit('setSession', data.user_info.session);
			store.commit('setSaasInfo', data.saas_info);
			store.commit('setUserInfo', data.user_info);
			store.commit('setNav', data.user_menu_list || []);
			store.commit('setAuth', Array.from(data.user_menu_key_list, item => item.menu_unique_key));
		},
		
		getAsyncDict(store, dict) {
			store.commit('updateAsyncDict', {
				dict: dict,
				data: []
			});
			
			app.request({
				url: '/dic/info/options',
				data: {
					dic_type_code: dict
				},
				success: data => {
					store.commit('updateAsyncDict', {
						dict,
						data
					});
				}
			})
		}
	},

	plugins: [createPersistedState({
		key: 'session',
		paths: ['session', 'saasInfo', 'userInfo', 'navList', 'authList'],
		storage: {
			getItem(key) {
				try {
					return JSON.parse(cryptoJs.AES.decrypt(localStorage.getItem(key), 'session').toString(cryptoJs.enc.Utf8));
				} catch(e) {
					return undefined;
				}
			},
			
			setItem(key, val) {
				localStorage.setItem(key, cryptoJs.AES.encrypt(JSON.stringify(val), 'session').toString());
			},
			
			removeItem(key) {
				localStorage.removeItem(key);
			}
		}
	})]
});
export default Store

const asyncMapState = function(data) {
	const res = {};
	data.forEach(dict => {
		res[dict] = {
			get() {
				if (!Store.state.asyncDictList[dict]) {
					Store.dispatch('getAsyncDict', dict);
				}
				
				return Store.state.asyncDictList[dict];
			},
			set() {}
		}
	});
	return res;
}
export {
	asyncMapState
}
